<template>
  <div>
    <vue-loading :active="isLoading" :is-full-page="true" />

    <DataGrid
      :items="shopsWithAddress"
      aria-label="Shop list"
      @row-clicked="onRowClicked"
      :selectedId="selectedShop ? selectedShop.id : null"
    >
      <template #row="{ item }">
        <td class="shop-image-cell">
          <img :src="item.image" :alt="item.name + ' image'" class="shop-image" width="120" height="80" />
        </td>
        <td class="shop-info-cell">
          <div class="shop-name">{{ item.name }}</div>
          <div class="shop-address" v-html="item.formattedAddress"></div>
        </td>
      </template>
    </DataGrid>
  </div>
</template>

<script>
import VueLoading from 'vue-loading-overlay'
import DataGrid from '../../data-display/DataGrid.vue'
import Utils from "@/utils/utils";
import {shopService} from "@/services/api/shopService";
import {useBasketStore} from "@/stores/basket";

export default {
  data() {
    return {
      isLoading: false,
      shops: [],
      selectedShop: null,
    }
  },
  async created() {
    await this.loadShops();
  },
  props: {
    callback: {
      Type: Function
    },
    shopId:{
      Type: Number,
      Default: 0
    },
  },
  setup() {
    const basketService = useBasketStore();

    return {
      basketService,
    };
  },
  computed: {
    shopsWithAddress() {
      return this.shops.map(shop => ({
        ...shop,
        formattedAddress: shop.addresses?.[0]?.formattedAddress || ''
      }));
    }
  },
  methods: {
    async loadShops() {
      this.isLoading = true;
      let response;
      if (this.shopId) {
        response = await shopService.getShop(this.shopId);
        // Normalize to array for shops list
        if (response && response.shop) {
          response.shops = [response.shop];
        } else if (response) {
          response.shops = [response]; // fallback if API returns shop directly
        } else {
          response.shops = [];
        }
      } else {
        response = await shopService.getShops(true);
      }
      this.isLoading = false;

      if (Utils.isEmpty(response.shops)) {
        this.makeToast('danger', this.$t('notification.noShopsAvailable'));
        return;
      }

      this.shops = response.shops;
      if (this.shops.length === 1) {
        // TODO make better
        // await this.selectShop(this.shops[0].id);
      }
    },
    async selectShop(shopId) {
      this.isLoading = true;
      try {
        const result = await shopService.selectShopById(shopId, true);
        this.selectedShop = result.shop;
        this.$emit('shop-selected', this.selectedShop); // Emit event to parent
      } finally {
        this.isLoading = false;
      }
    },
    onRowClicked(shop) {
      this.selectShop(shop.id);
    },
  },
  components: {
    VueLoading,
    DataGrid,
  },
  watch: {
    '$i18n.locale': function(newVal, oldVal) {
      if(newVal != oldVal)
      {
        this.loadShops();
      }
    }
  },
}
</script>

<style scoped>
.shop-image {
  width: 120px;
  height: auto;
  object-fit: cover;
}
.shop-name {
  font-weight: bold;
  text-align: left;
}
.shop-address {
  text-align: left;
}
</style>
